import { render, staticRenderFns } from "./AddPractice.vue?vue&type=template&id=10636cbc&scoped=true"
import script from "./AddPractice.vue?vue&type=script&lang=js"
export * from "./AddPractice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10636cbc",
  null
  
)

export default component.exports